import { createSelector } from "reselect";
import { MONTH_VIEW, MULTIPLE_ARTIST_VIEW, SINGLE_ARTIST_VIEW } from "./CalendarReducer";

// View type check utilities (still needed - check against view type values)
export const isMultipleArtistView = viewType => viewType === MULTIPLE_ARTIST_VIEW
export const isSingleArtistView = viewType => viewType === SINGLE_ARTIST_VIEW
export const isMonthView = viewType => viewType === MONTH_VIEW

export const selectCalendarState = createSelector(
    [(state) => state]
    , (state) => state.calendar ?? {}
)


// ============================================================================
// Active Selectors (non-settings state - stays in Redux)
// ============================================================================

export const selectSelectedKundIDCalendar = createSelector([selectCalendarState], (state) => state?.selectedKundID)

// Termin selection (ID only - termin data loaded via TanStack Query useCalendarTerminToasterQuery)
export const selectSelectedTerminIDCalendar = createSelector([selectCalendarState], (state) => state?.selectedTerminID)

/**
 * Selector for the termin selection context.
 * Contains { artistId, start } to detect when manual view changes should clear the marker.
 */
export const selectSelectedTerminContext = createSelector([selectCalendarState], (state) => state?.selectedTerminContext)

/**
 * Selector for customer search UI state.
 * Returns persisted search string, settings and selected searched customer id.
 */
export const selectCalendarCustomerSearchState = createSelector(
    [selectCalendarState],
    (state) => state?.customerSearchState || {
        searchString: "",
        settings: {},
        selectedSearchedKundId: null,
    }
)
